import { render, staticRenderFns } from "./ChipLoginOratore.vue?vue&type=template&id=7c249920&scoped=true&"
import script from "./ChipLoginOratore.vue?vue&type=script&lang=js&"
export * from "./ChipLoginOratore.vue?vue&type=script&lang=js&"
import style0 from "./ChipLoginOratore.vue?vue&type=style&index=0&id=7c249920&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c249920",
  null
  
)

export default component.exports